import { areHawaiianNamesEquivalent, normalizeHawaiianName } from './utils'
import { getPhotoSpotRegion } from './photoPlannerConfig'

const toArray = (value) => (Array.isArray(value) ? value.filter(Boolean) : [])

export function applyPhotoFilters(
  spots,
  {
    island = 'kauai',
    region = [],
    categories = [],
    searchText = ''
  }
) {
  const regionFilters = toArray(region)
  const categoryFilters = toArray(categories)
  const normalizedText = normalizeHawaiianName(searchText || '').toLowerCase()
  const normalizeField = (value) => normalizeHawaiianName(String(value || '')).toLowerCase()

  return toArray(spots).filter((spot) => {
    const spotIsland = String(spot.island || 'kauai').toLowerCase()
    const matchesIsland = !island || spotIsland === String(island).toLowerCase()

    const spotRegion = getPhotoSpotRegion(spot)

    const matchesRegion = regionFilters.length
      ? regionFilters.some((filterRegion) => areHawaiianNamesEquivalent(filterRegion, spotRegion))
      : true

    const spotCategories = Array.isArray(spot.photoCategories) ? spot.photoCategories : []
    const matchesCategories = categoryFilters.length
      ? categoryFilters.some((c) => spotCategories.includes(c))
      : true

    const inText =
      !normalizedText ||
      normalizeField(spot.name).includes(normalizedText) ||
      normalizeField(spot.shortDescription).includes(normalizedText) ||
      normalizeField(spot.bestSeasonNotes).includes(normalizedText) ||
      normalizeField(spotCategories.join(' ')).includes(normalizedText)

    return matchesIsland && matchesRegion && matchesCategories && inText
  })
}
